export default () => ({
  isAuthenticated: false
})
